function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon-error_svg__a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#D58800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFE700"
})));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#icon-error_svg__a)",
  fillRule: "evenodd",
  d: "M757.53 2206.039c.129.08.238.189.318.318l8.196 13.113a1.001 1.001 0 01-.848 1.53h-16.392a1 1 0 01-.848-1.53l8.196-13.113a1 1 0 011.378-.318zm.354 11.211h-1.876v1.75h1.876v-1.75zm-.056-8.246h-1.75v2.884l.462 4.326h.826l.462-4.326v-2.884z",
  transform: "translate(-747 -2205)"
});
function SvgIconError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='16' viewBox='0 0 20 16'%3e %3cdefs%3e %3clinearGradient id='prefix__a' x1='50%25' x2='50%25' y1='100%25' y2='0%25'%3e %3cstop offset='0%25' stop-color='%23D58800'/%3e %3cstop offset='100%25' stop-color='%23FFE700'/%3e %3c/linearGradient%3e %3c/defs%3e %3cpath fill='url(%23prefix__a)' fill-rule='evenodd' d='M757.53 2206.039c.129.08.238.189.318.318l8.196 13.113c.292.468.15 1.085-.318 1.378-.16.1-.343.152-.53.152h-16.392c-.552 0-1-.448-1-1 0-.187.053-.371.152-.53l8.196-13.113c.293-.469.91-.61 1.378-.318zm.354 11.211h-1.876v1.75h1.876v-1.75zm-.056-8.246h-1.75v2.884l.462 4.326h.826l.462-4.326v-2.884z' transform='translate(-747 -2205)'/%3e %3c/svg%3e";
export { SvgIconError as ReactComponent };